import React from "react";
import styled from "styled-components";
import { RouteComponentProps, withRouter } from "react-router";
import { Capsule } from "@sonder/ui/source/styled/fragments/Capsule";
import { TabButton } from "@sonder/ui/source/styled/fragments/TabButton";
import { TabGroup } from "@sonder/ui/source/styled/fragments/TabGroup";
import { TaskData } from "core/queries/GetTasks";
import { mapTaskFeedItemToUnread } from "core/queries/mappers";
import { normalizeType } from "tasks/helpers";
import { TypeEnum } from "typings/globalGQLTypes";

interface TaskPanelTabs extends RouteComponentProps {
  task: TaskData;
}

const TaskCapsule = styled(Capsule)`
  position: absolute;
  right: 0;
  transform: translate(75%, -37.5%) scale(0.75);
`;

export const TaskPanelTabs = withRouter(
  ({ task, history, location, match }: TaskPanelTabs) => {
    const baseRoute = match.url;
    const unreadCount = mapTaskFeedItemToUnread(task);
    const normalizedTaskType = normalizeType(task.type);
    const isSpaceCleanTask =
      normalizedTaskType === TypeEnum.Tom_Tasks_SpaceClean;
    return (
      <TabGroup>
        <TabButton
          selected={location.pathname === baseRoute}
          onClick={() => history.push(`${baseRoute}`)}
        >
          Details
        </TabButton>
        <TabButton
          selected={location.pathname === `${baseRoute}/activity`}
          onClick={() => history.push(`${baseRoute}/activity`)}
        >
          Activity
          {!!unreadCount && (
            <TaskCapsule>{unreadCount > 99 ? `99+` : unreadCount}</TaskCapsule>
          )}
        </TabButton>
        {!isSpaceCleanTask && (
          <>
            <TabButton
              selected={location.pathname === `${baseRoute}/guest`}
              onClick={() => history.push(`${baseRoute}/guest`)}
            >
              Guest
            </TabButton>
            <TabButton
              selected={location.pathname === `${baseRoute}/unit`}
              onClick={() => history.push(`${baseRoute}/unit`)}
            >
              Unit
            </TabButton>
          </>
        )}
      </TabGroup>
    );
  },
);
